// import { VuetifyTheme } from 'vuetify'

export interface PrologueTheme {
    key: string
    name: string
    vuetifyTheme: Partial<any>
}

export default [
    {
        key: 'garnet',
        name: 'Granate',
        vuetifyTheme: {
            primary: '#7c3f4c',
            secondary: '#db4572',
            accent: '#f9b9ec',
            error: '#831f33',
        },
    },
    {
        key: 'pearl',
        name: 'Perla',
        vuetifyTheme: {
            primary: '#eca1b4',
            secondary: '#eecbb3',
            accent: '#cdebee',
            error: '#eecbb3',
        },
    },
    {
        key: 'lapis',
        name: 'Lapis Lazuli',
        vuetifyTheme: {
            primary: '#3a55b4',
            secondary: '#6caddf',
            accent: '#8cd9ff',
            error: '#45476E',
        },
    },
    {
        key: 'rei',
        name: 'Rei',
        vuetifyTheme: {
            primary: '#304860',
            secondary: '#304848',
            accent: '#A8C0D8',
            error: '#A8A8A8',
        },
    },
 ] as PrologueTheme[]
